import React from "react";
import "./PluginSelector.css";

const PluginSelector = ({ plugins, onPluginToggle }) => {
  if (!plugins || plugins.length === 0) {
      return <p>No plugins found</p>;
  }
  return (
      <div>
          <ul className="plugin-selector-list">
              {plugins.map((plugin) => (
                  <li
                      key={plugin.id}
                      onClick={() => onPluginToggle(plugin.id)}
                      className={plugin.isSelected ? "plugin-selector-item selected" : "plugin-selector-item deselected"}
                  >
                      {plugin.productName}
                  </li>
              ))}
          </ul>
      </div>
  );
};

export default PluginSelector;